module.exports = __webpack_public_path__ + "img/title_food@2x.c9532320.png";